export class Logger {
  // 'none' | 'all' | 'debug' | 'info' | 'warn' | 'error'

  private logLevel: Array<string> = ['none'];

  constructor() {
    this.fillLogLevel();
  }

  /**
   * sets the log level globally.
   * You have to define in your local storage which loglevel you want
   * key = log; value = all;
   */
  private fillLogLevel() {
    if (window.localStorage.getItem('log')) {
      const level = window.localStorage.getItem('log');

      switch (level) {
        case 'all':
          this.logLevel = [];
          this.logLevel.push('debug', 'info', 'warn', 'error');
          break;
        case 'none':
          this.logLevel = ['none'];
          break;
        case 'debug':
          this.logLevel = [];
          this.logLevel.push('debug', 'info', 'warn', 'error');
          break;
        case 'info':
          this.logLevel = [];
          this.logLevel.push('info', 'warn', 'error');
          break;
        case 'warn':
          this.logLevel = [];
          this.logLevel.push('warn', 'error');
          break;
        case 'error':
          this.logLevel = [];
          this.logLevel.push('error');
          break;
        default:
          this.logLevel = ['none'];
          break;
      }
    }
  }

  /**
   * Simple logging. Default writes the log to the debug buffer
   * @param message any message you want to display
   * @param optionalParams any information you want to display
   */
  public log(message?: any, ...optionalParams: any[]): void {
    this.debug(message, optionalParams);
  }

  /**
   * Debug Loglevel
   * @param message any message you want to display
   * @param optionalParams any information you want to display
   */
  public debug(message?: any, ...optionalParams: any[]): void {
    if (this.logLevel.includes('debug')) {
      console.debug(message, optionalParams);
    }
  }

  /**
   * Error Loglevel
   * @param message any message you want to display
   * @param optionalParams any information you want to display
   */
  public error(message?: any, ...optionalParams: any[]): void {
    if (this.logLevel.includes('error')) {
      console.error(message, optionalParams);
    }
  }

  /**
   * Warn Loglevel
   * @param message any message you want to display
   * @param optionalParams any information you want to display
   */
  public warn(message?: any, ...optionalParams: any[]): void {
    if (this.logLevel.includes('warn')) {
      console.warn(message, optionalParams);
    }
  }

  /**
   * Info LogLevel
   * @param message any message you want to display
   * @param optionalParams any information you want to display
   */
  public info(message?: any, ...optionalParams: any[]): void {
    if (this.logLevel.includes('info')) {
      console.info(message, optionalParams);
    }
  }
}
